// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = require('./dist/cjs/handlebars.runtime')['default'];



// WEBPACK FOOTER //
// ./node_modules/handlebars/runtime.js